import { render } from "./Lottery.vue?vue&type=template&id=e7b55bf2&scoped=true"
import script from "./Lottery.vue?vue&type=script&lang=js"
export * from "./Lottery.vue?vue&type=script&lang=js"

import "./Lottery.vue?vue&type=style&index=0&id=e7b55bf2&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7b55bf2"]])

export default __exports__